import keyMirror from "keymirror";

export default keyMirror({
  SET_LOADING: null,
  SHOW_NOTIF: null,
  HIDE_NOTIF: null,
  HIDE_ALL_NOTIFS: null,
  INIT_ROUTING_DATA: null,
});
